import React from 'react'
import { connect } from 'react-redux'
import './horiz-progress-bar.scss'

const HorizProgressBar = props => {
	return (
		<div className='progress-bar-wrapper'>
			<div className='background-icon icon-videoCam'></div>
			<div class='progress'>
				<div
					role='progressbar'
					class='progress-bar progress-bar-animated progress-bar-striped'
					aria-valuenow='45'
					aria-valuemin='0'
					aria-valuemax='100'
					style={{
						width: `${props.percentage}%`,
					}}
				></div>
			</div>
			<div className='progress-text'>
				{props.percentage <= 50 ? `Uploading Video ${props.percentage}%` : `Processing Video ${props.percentage}%`}
			</div>
		</div>
	)
}

const mapStateToProps = (state, props) => {
	const newState = {
		videoData: state.videoupload.videos[props.videoKey] || {},
	}
	newState.percentage = newState.videoData.progress || 0
	return newState
}

export default connect(mapStateToProps, {})(HorizProgressBar)
